import React from 'react';
import { useRouter } from 'next/router';

import { SearchOption } from '../../common/helpers/searchOption.utils';
import useCountyCityZone from '../../common/hooks/useCountyCityZone';
import { IMapArea } from '../../common/model/mapArea.model';
import { FlatBreadcrumb } from '../shared';

type Props = {
  searchOptions: SearchOption[];
  mapArea?: IMapArea;
};

const SearchBreadcrumb: React.FC<Props> = ({ searchOptions, mapArea }) => {
  const router = useRouter();

  const [county, city, zone] = useCountyCityZone();

  return (
    <div>
      <FlatBreadcrumb
        searchOptions={searchOptions}
        mapArea={mapArea}
        county={county}
        city={city}
        zone={zone}
        flatType={router.query.flatType as string}
      />
    </div>
  );
};

export default SearchBreadcrumb;
